export default __webpack_public_path__ + "static/media/televisions-dark.771dac3b.svg";